
<Modal
  modalType="StrokeWidth"
  mayCancel="true"
  v-on:cancel="onDone"
  anchorStyle="topAuto"
>
  <div class="BrushCollection">
    <div
      v-bind:class="getSWClass(sw)"
      v-for="sw in strokeWidths"
      v-bind:key="sw"
      v-on:click="setStrokeWidth(sw)"
    >
      <div
        class="StrokeWidthIndicator_Circle"
        v-bind:style="getStrokeWidthCircleStyle(sw)"
      ></div>
    </div>
  </div>
</Modal>
